import { render, staticRenderFns } from "./Moderation.vue?vue&type=template&id=0eb086d5&"
import script from "./Moderation.vue?vue&type=script&lang=js&"
export * from "./Moderation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports